
import React, { useCallback } from 'react';
import moment from 'moment';
import * as reportCss from './DetailReport.css.js';

const ReportPeriod = ({ reportMap, setReportMap, beginDate, endDate }) => {
  const handleChangePeriod = useCallback((type, value) => {
    setReportMap(reportMap => {
      return {
        ...reportMap,
        'period': {
          ...reportMap.period,
          'selectedPeriod': type === 'temporary' ? {
            regular: false,
            week: false,
            month: false,
            quater: false,
            half: false,
            year: false,
            temporary: true,
          } : {
            regular: true,
            week: false,
            month: false,
            quater: false,
            half: false,
            year: false,
            [type]: value,
            temporary: false
          }
        }
      }
    })
  })

  return (
    <>
      <reportCss.PeriodTitleBar>
        <span>1. 대상기간</span>
        &nbsp;&nbsp;&nbsp;&nbsp;{moment(beginDate).format('YYYY-MM-DD')}부터 {moment(endDate).format('YYYY-MM-DD')}까지
      </reportCss.PeriodTitleBar>
      <reportCss.PeriodContent>
        <table>
          <tbody>
            <tr>
              <td>정례</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.regular} 
                         onChange={({target}) => { handleChangePeriod('regular', target.checked) }}/></td>
              <td>주간</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.week} 
                         onChange={({target}) => { handleChangePeriod('week', target.checked) }}/></td>
              <td>월간</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.month} 
                         onChange={({target}) => { handleChangePeriod('month', target.checked) }}/></td>
              <td>분기</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.quater} 
                         onChange={({target}) => { handleChangePeriod('quater', target.checked) }}/></td>
              <td>반기</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.half} 
                         onChange={({target}) => { handleChangePeriod('half', target.checked) }}/></td>
              <td>연간</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.year} 
                         onChange={({target}) => { handleChangePeriod('year', target.checked) }}/></td>
            </tr>
            <tr>
              <td>임시</td>
              <td><input type="radio" checked={reportMap.period.selectedPeriod.temporary}  
                         onChange={({target}) => { handleChangePeriod('temporary', target.checked) }}/></td>
            </tr>
          </tbody>
        </table>
      </reportCss.PeriodContent>
    </>
  )
}

export default React.memo(ReportPeriod);